// Equivalente web do ActivityIndicator do app original.
export function Spinner({
  size = 32,
  className = "border-border border-t-tint",
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      role="status"
      aria-label="Carregando"
      className={`inline-block animate-spin rounded-full border-2 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function ScreenSpinner() {
  return (
    <div className="flex h-64 items-center justify-center">
      <Spinner />
    </div>
  );
}
